export const COLLECTIONS = {
    users: "user",
    stories: "stories",
    chapters: "chapters",
    recordings: "recordings",
    greetings: "greetings",
    invites: "invites",
};
export const pathTo = {
    storage: {
        greetingsCollection: (userId) => [COLLECTIONS.users, userId, COLLECTIONS.greetings].join("/"),
        greeting: (userId, greetingId) => [COLLECTIONS.users, userId, COLLECTIONS.greetings, greetingId].join("/"),
        storyRecordingsCollection: (storyId) => [COLLECTIONS.stories, storyId, COLLECTIONS.recordings].join("/"),
        story: (storyId) => [COLLECTIONS.stories, storyId].join("/"),
        chapterRecordingsCollection: (storyId, chapterId) => [
            COLLECTIONS.stories,
            storyId,
            COLLECTIONS.recordings,
            chapterId,
            COLLECTIONS.recordings,
        ].join("/"),
        unconvertedChapterRecording: (storyId, chapterId) => [
            COLLECTIONS.stories,
            storyId,
            COLLECTIONS.recordings,
            chapterId,
            COLLECTIONS.recordings,
            "unconverted",
        ].join("/"),
        convertedChapterRecording: (storyId, chapterId) => [
            COLLECTIONS.stories,
            storyId,
            COLLECTIONS.recordings,
            chapterId,
            COLLECTIONS.recordings,
            "converted.mp3",
        ].join("/"),
        copyOfOriginalChapterRecording: (storyId, chapterId) => [
            COLLECTIONS.stories,
            storyId,
            COLLECTIONS.recordings,
            chapterId,
            COLLECTIONS.recordings,
            "copyOfOriginal",
        ].join("/"),
        toBeConcattedChapterRecording: (storyId, chapterId) => [
            COLLECTIONS.stories,
            storyId,
            COLLECTIONS.recordings,
            chapterId,
            COLLECTIONS.recordings,
            "toBeConcatted",
        ].join("/"),
        concattedChapterRecording: (storyId, chapterId) => [
            COLLECTIONS.stories,
            storyId,
            COLLECTIONS.recordings,
            chapterId,
            COLLECTIONS.recordings,
            "concatted.mp3",
        ].join("/"),
        normalizedChapterRecording: (storyId, chapterId) => [
            COLLECTIONS.stories,
            storyId,
            COLLECTIONS.recordings,
            chapterId,
            COLLECTIONS.recordings,
            "normalized.mp3",
        ].join("/"),
        zippedStories: (userId, filename) => [COLLECTIONS.users, userId, filename].join("/"),
        zippedStory: (storyId, filename) => [COLLECTIONS.stories, storyId, filename].join("/"),
        user: (userId) => [COLLECTIONS.users, userId].join("/"),
        unconvertedArbitraryRecording: (userId) => [COLLECTIONS.users, userId, "unconverted"].join("/"),
        convertedArbitraryRecording: (userId) => [COLLECTIONS.users, userId, "converted.mp3"].join("/"),
        normalizedArbitraryRecording: (userId) => [COLLECTIONS.users, userId, "normalized.mp3"].join("/"),
    },
    db: {
        invitesCollection: () => COLLECTIONS.invites,
        revokedInvites: () => [pathTo.db.invitesCollection(), "revoked"].join("/"),
        usersCollection: () => COLLECTIONS.users,
        user: (userId) => [pathTo.db.usersCollection(), userId].join("/"),
        storiesCollection: () => COLLECTIONS.stories,
        story: (storyId) => [pathTo.db.storiesCollection(), storyId].join("/"),
        storyRecordingsCollection: (storyId) => [pathTo.db.story(storyId), COLLECTIONS.recordings].join("/"),
        storyRecording: (storyId, type) => [pathTo.db.storyRecordingsCollection(storyId), type].join("/"),
        greetingsCollection: (userId) => [pathTo.db.user(userId), COLLECTIONS.greetings].join("/"),
        greeting: (userId, type) => [pathTo.db.greetingsCollection(userId), type].join("/"),
        chaptersCollection: (storyId) => [pathTo.db.story(storyId), COLLECTIONS.chapters].join("/"),
        chapter: (storyId, chapterId) => [pathTo.db.chaptersCollection(storyId), chapterId].join("/"),
        chapterRecordingsCollection: (storyId, chapterId) => [pathTo.db.chapter(storyId, chapterId), COLLECTIONS.recordings].join("/"),
        chapterRecording: (storyId, chapterId, type) => [pathTo.db.chapterRecordingsCollection(storyId, chapterId), type].join("/"),
    },
};
//# sourceMappingURL=pathTo.js.map